export default "__VITE_ASSET__IRBOr3dy__"